export function getCookieValue(name: string): string | undefined {
  const cookie = document.cookie.match(
    new RegExp('(^| )' + name + '=([^;]+)')
  );

  if (cookie) return cookie[2];
}